import unfavouriteCarpiProductConfiguration from '@/actions/productWorkflow/carpi/productConfiguration/unfavouriteCarpiProductConfiguration';
import { useCallback } from 'react';
import useNotification from '../useNotification';
import useTranslations from '../useTranslations';
import { useRouter } from 'next/navigation';
import useAuth from '@/lib/firebase/auth/store';

export default function useUnfavourite(existingCarpiProductConfigurationId: string) {
  const notifications = useNotification();
  const { t, locale } = useTranslations();
  const router = useRouter();
  const { userId } = useAuth();

  const handleUnfavouriting = useCallback(async () => {
    try {
      await unfavouriteCarpiProductConfiguration(
        existingCarpiProductConfigurationId,
        locale,
        userId,
      );

      // Small delay to ensure revalidation completes
      await new Promise((resolve) => setTimeout(resolve, 100));

      router.refresh();
      notifications.success(t('product.workflow.unFavourite.success'));
    } catch (error) {
      console.error(error);
      notifications.error(t('product.workflow.unFavourite.error'));
    }
  }, [existingCarpiProductConfigurationId, locale, notifications, router, t, userId]);

  return { handleUnfavouriting };
}
